// GoogleAnalytics.tsx

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { config } from '@/lib/config';

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Load Google Analytics script only once.
        if (!document.getElementById('ga-gtag-js')) {
            const script1 = document.createElement('script');
            script1.id = 'ga-gtag-js';
            script1.src = `https://www.googletagmanager.com/gtag/js?id=${config.GA_ID}`;
            script1.async = true;
            document.head.appendChild(script1);
        }

        if (!document.getElementById('ga-init-script')) {
            const script2 = document.createElement('script');
            script2.id = 'ga-init-script';
            script2.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                // Initial config uses current path; route changes are handled below.
                gtag('config', '${config.GA_ID}', {
                    page_path: window.location.pathname,
                });
            `;
            document.head.appendChild(script2);
        }
    }, []);

    useEffect(() => {
        // Send a page_view on SPA navigation.
        const gtag = (window as any).gtag;
        if (typeof gtag !== 'function') return;

        gtag('config', config.GA_ID, {
            page_path: location.pathname,
        });
    }, [location.pathname]);

    return null;
};

export default GoogleAnalytics;
